// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Ireland from '../_raw/flag/icon_flag_ireland.png';

export default () => <img src={Ireland} alt="Ireland" />;
